const carouselItems = [
  {
    tag: '热播大剧',
    title: '《暗夜追光》',
    desc: '年度悬疑犯罪力作，豆瓣8.7分，全24集完整版高清在线观看。剧情环环相扣，演技全员在线，智能推荐为您关联同类型佳作。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20crime%20drama%20cinematic%20poster%20style%2C%20noir%20atmosphere%20with%20warm%20golden%20accent%20light%2C%20suspenseful%20mood%2C%20film%20noir%20aesthetic%2C%20dramatic%20shadow%20play%2C%20dark%20alley%20with%20single%20streetlamp%2C%20cinematic%20composition%2C%20movie%20poster%20quality&width=800&height=500&seq=carousel-01-dark-night&orientation=landscape',
  },
  {
    tag: '口碑推荐',
    title: '《长安浮生录》',
    desc: '古装权谋史诗，制作精良场景宏大，全网热议追剧首选。最新剧集完整版持续更新，不缓冲流畅播放。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20cinematic%20visual%2C%20traditional%20architecture%20with%20golden%20lanterns%2C%20warm%20amber%20lighting%2C%20historical%20costume%20aesthetic%2C%20elegant%20composition%2C%20rich%20textures%2C%20film%20quality%20atmosphere%2C%20soft%20bokeh%20background&width=800&height=500&seq=carousel-02-changan&orientation=landscape',
  },
  {
    tag: '新片上线',
    title: '《星际迷途3》',
    desc: '科幻巨制震撼视觉体验，4K修复画质独家上线。电影大全片库重磅新成员，高清画质即点即播。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20starry%20space%20background%2C%20deep%20blue%20and%20purple%20nebula%20tones%2C%20starship%20silhouette%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20film%20poster%20aesthetic%2C%20mysterious%20cosmic%20atmosphere%2C%20professional%20cinematic%20composition&width=800&height=500&seq=carousel-03-scifi&orientation=landscape',
  },
  {
    tag: '专题策划',
    title: '「暑期追剧指南」',
    desc: '精选50部高分好剧一网打尽，悬疑甜宠古装科幻全覆盖。快速找片不迷茫，智能推荐助您发现下一部心头好。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20summer%20evening%20home%20cinema%20setup%2C%20cozy%20blanket%20and%20popcorn%20on%20sofa%2C%20soft%20warm%20lighting%20from%20string%20lights%2C%20large%20screen%20with%20colorful%20movie%20poster%20collage%2C%20inviting%20relaxed%20atmosphere%2C%20golden%20hour%20warmth%2C%20comfortable%20entertainment%20vibe&width=800&height=500&seq=carousel-04-summer&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500">编辑精选，不容错过的热门影视内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300 hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={`黄瓜影院${item.tag} - ${item.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}